// extracted by mini-css-extract-plugin
export default {"contactList":"ContactList_contactList__0E4t8"};